import React from "react";
import { useHistory } from "react-router-dom";
import withStyles from '@mui/styles/withStyles';
import iconBlueClose from "../../assets/images/icon_blue_close.svg";

const topOffset = "10%";
const button = {
  border: "none",
  textTransform: "uppercase",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "30px",
  padding: "10px",
  width: "100%",
  color: "white",
  backgroundColor: "#8C8C96",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  purchaseConfirmation: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    backgroundColor: "white",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    maxHeight: "100vh",
    overflowY: "auto",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
  },
  wrapper: {
    padding: "28px 0px 0px 0px",
  },
  block: block,
  blockWithDelimiter: {
    ...block,
    borderBottom: "1px solid #70707052",
    marginTop: "20px",
    marginBottom: "20px",
  },
  blueText: {
    color: "#238CB9",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "12px",
    padding: "21px 0px",
  },
  button: button,
  buttonRed: {
    ...button,
    backgroundColor: "#D93140",
    marginTop: "20px",
  },
  buttonWhite: {
    ...button,
    color: "#383838",
    backgroundColor: "#ffffff",
    border: "1px solid #707070",
  },
  couponCode: {
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "18px",
    padding: "8px 0px 30px 0px",
  },
  barCode: {
    marginBottom: "50px",
  }
});

function KyteTecMemberPurchaseModal({
  classes,
  campaignId,
  setShowPurchaseModal,
  couponCode,
}) {
  let history = useHistory();

  const routeToCoupon = (campaignId) => {
    return (e) => {
      e.preventDefault();
      history.push(`/my-coupon/${campaignId}`);
    };
  };

  return (
    <div id="scrollable-modal" className={classes.root}>
      <div className={classes.purchaseConfirmation}>
        <div style={{ position: "relative" }}>
          <img
            className={classes.closeIcon}
            src={iconBlueClose}
            alt="Close purchase modal"
            onClick={(e) => setShowPurchaseModal(false)}
          />
          <div className={classes.wrapper}>
            <div style={{paddingBottom: "60px"}} className={classes.blockWithDelimiter}>
              <div className={classes.blueText}>Code an der Apothken-Kasse Scannen und direkt <br/> Deinen Rabatt erhalten</div>
            </div>
            <div className={classes.block} style={{marginBottom: "280px", marginTop: "50px"}}>
              <div style={{ width: "100%" }}>
                <button
                  className={classes.buttonWhite}
                  onClick={routeToCoupon(campaignId)}
                >
                  Coupon Details anzeigen
                </button>
              </div>
              <div style={{ width: "100%" }}>
                <button
                  className={classes.buttonRed}
                  onClick={() => setShowPurchaseModal(false)}
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(KyteTecMemberPurchaseModal);
